import { theme } from '../../lib'
import { StyledIcon } from './icon.styles'
import { IconMap, IconProps } from './icon.types'

export const Icon = ({
  color = 'mauve10',
  name,
  rotate,
  size = 'small'
}: IconProps) => {
  const TheIcon = IconMap[name]
  return (
    <StyledIcon
      css={{
        '& path': {
          fill: theme.colors[color]
        }
      }}
      rotate={rotate}
      size={size}
    >
      <TheIcon />
    </StyledIcon>
  )
}
